import {Component, OnInit, OnDestroy} from '@angular/core';
import {UsersService, IUser, IRegion2} from '../users.service';
import {UsersFormComponent} from '../users-form/users-form.component';
import {RolesService, IRole, IWidget, IDepartment, ICompany} from '../../roles/roles.service';
import {combineLatest} from 'rxjs';
import {MatDialog} from '@angular/material/dialog';
import {MatTableDataSource} from '@angular/material/table';
import {finalize} from 'rxjs/operators';

@Component({
  selector: 'app-users-list',
  templateUrl: './users-list.component.html',
  styleUrls: ['./users-list.component.scss']
})
export class UsersListComponent implements OnInit, OnDestroy {

  displayedColumns = ['id', 'fullName', 'email', 'usersRoles', 'usersDepartment', 'option'];
  users: MatTableDataSource<IUser>;
  mainUsers: IUser[] = [];
  loading = false;
  combined = null;
  roles: IRoleEx[] = [];
  regionList: IRegion2[] = [];
  selectedUserType = false;
  companies: ICompany[] = [];

  constructor(
    public dialog: MatDialog,
    private service: UsersService,
    private roleService: RolesService) {
  }

  ngOnInit() {
    this.loadList();
  }

  ngOnDestroy() {
    this.combined.unsubscribe();
  }

  loadList() {
    this.loading = true;
    this.combined = combineLatest([
      this.service.getUsers(),
      this.roleService.getList(),
      this.roleService.getWidgets(),
      this.service.getRegionList(),
      this.roleService.getDepartments()
    ])
      .pipe(
        finalize(() => {
          this.loading = false;
        })
      )
      .subscribe(res => {
        this.mainUsers = res[0];
        this.service.saveUsers.emit(this.mainUsers);
        this.selectUserType(false);
        this.roles = this.updateRoles(res[1], res[2]);
        this.regionList = res[3];
        this.companies = res[4];
      });
  }

  selectUserType(flag: boolean) {
    this.selectedUserType = flag;
    this.users = new MatTableDataSource(this.mainUsers.filter(f => f.lockoutEnabled === flag));
  }

  applyFilter(event: Event) {
    this.users.filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
  }

  createUser() {
    const data: IUser = {
      id: '',
      email: '',
      lastName: '',
      firstName: '',
      middleName: '',
      mioID: null,
      phoneNumber: '',
      Password: '',
      ConfirmPassword: '',
      roles: [],
      companyID: null,
      departmentID: null,
      lockoutEnabled: false
    };
    this.dialog.open(UsersFormComponent, {
      width: '80%',
      height: '85%',
      data: {type: 'create', data: data, roles: this.roles, regionList: this.regionList, companies: this.companies},
      disableClose: true,
    }).afterClosed().subscribe(result => {
      if (result) {
        if (result === 'cool') {
          this.loadList();
        }
      }
    });
  }

  updateRoles(roles: IRole[], widgets: IWidget[]) {
    const res: IRoleEx[] = roles.map(role => {
      return {
        id: role.id,
        name: role.name,
        description: role.description,
        widgets: role.widgets,
        widgetsEx: []
      };
    });
    res.forEach(r => {
      r.widgets.forEach(rw => {
        const fWidget = widgets.find(w => w.id === rw);
        r.widgetsEx.push(fWidget);
      });
    });
    return res;
  }

  getDepartmentByID(companyID: number, departmentID: number) {
    let department: IDepartment;
    let departments: IDepartment[];
    let title = '';
    if (companyID !== null && departmentID !== null && companyID !== undefined && departmentID !== undefined) {
      const company: ICompany = this.companies.find(x => x.id === companyID);
      if (company) {
        departments = company.departments;
        if (departments) {
          department = departments.find(x => x.id === departmentID);
          title = department.title;
        }
      }
    }
    return title;
  }

}


interface IRoleEx extends IRole {
  widgetsEx: IWidget[];
}
